const LOCALE = "en-GB";

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = /^\d{4}-\d{2}-\d{2}$/.test(iso) ? new Date(`${iso}T12:00:00Z`) : new Date(iso);
  return new Intl.DateTimeFormat(LOCALE, { dateStyle: "medium", timeZone: "UTC" }).format(d);
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  return new Intl.DateTimeFormat(LOCALE, { dateStyle: "medium", timeStyle: "short", timeZone: "UTC" }).format(
    new Date(iso),
  );
}

export const formatNumber = (n: number): string => new Intl.NumberFormat(LOCALE).format(n);

export const formatMoney = (cents: number | null | undefined, currency = "EUR"): string =>
  cents === null || cents === undefined
    ? "—"
    : new Intl.NumberFormat(LOCALE, { style: "currency", currency }).format(cents / 100);

export const formatPct = (n: number): string =>
  `${n > 0 ? "+" : ""}${new Intl.NumberFormat(LOCALE, { maximumFractionDigits: 1 }).format(n)}%`;

export const monthLabel = (ym: string): string =>
  new Intl.DateTimeFormat(LOCALE, { month: "short", year: "2-digit", timeZone: "UTC" }).format(
    new Date(`${ym}-01T12:00:00Z`),
  );
